import React from 'react';
import { sendDataLayer } from '../../utils/functions';

function ScrollButton({
  text,
  type,
  invert,
}) {

  const handler = () => {
    console.log("Scroll")
    
    if (type == 'banner') {
      const heightBanner = document.querySelector('.desktop-hero')

      if (heightBanner) {
        window.scrollTo({
          top: heightBanner.offsetHeight,
          behavior: 'smooth'
        });
      }

      sendDataLayer({ datalayer: { event: 'scroll_button', text: text, link: 'N/A', site_url: text.includes('canjear') ? '/premios' : text.includes('por más') ? '/mis-redenciones' : '/beneficios' }, repeat: true })
    }

  };

  return (
    <button className={`scroll-button ${invert ? 'has-invert' : ''}`} onClick={handler}>
      {text}
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M3.71209 9.80584C4.0782 9.43972 4.6718 9.43972 5.03791 9.80584L10 14.7679L14.9621 9.80584C15.3282 9.43972 15.9218 9.43972 16.2879 9.80584C16.654 10.172 16.654 10.7655 16.2879 11.1317L10.6629 16.7567C10.2968 17.1228 9.7032 17.1228 9.33709 16.7567L3.71209 11.1317C3.34597 10.7655 3.34597 10.172 3.71209 9.80584Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M10 2.96875C10.5178 2.96875 10.9375 3.38848 10.9375 3.90625V15.3125C10.9375 15.8303 10.5178 16.25 10 16.25C9.48223 16.25 9.0625 15.8303 9.0625 15.3125V3.90625C9.0625 3.38848 9.48223 2.96875 10 2.96875Z" fill="white"/>
      </svg>
    </button>
  );
}

export default ScrollButton;
